<template>
	<div>
		<div class="title">
			{{title}}
		</div>

		<div v-if="type=='text'" class="text_style" v-text="content">
		</div>

		<div v-if="type=='list'">
			<ul v-for="item in content" style="padding: 0;">
				<li style="list-style: none;color: #424242;margin-left:20px;font-size: 16px;font-family: 'Microsoft YaHei';line-height: 20px;">
					{{item}}
				</li>
			</ul>
		</div>

    




	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		props: {
			title: {
				type: String
			},
			content: {},
			
			type: {
				type: String,
				default () {
					return 'text'
				}
			}


		},
	}
</script>

<style scoped>
	.text_style {
		line-height: 28px;
		text-indent: 30px;
	}


	.title {
		font-size: 18px;
		background-image: url('../../assets/homePage/panelt.png');
		background-repeat: no-repeat;
		padding-left: 15px;
		background-position: left;
		margin: 15px 0;
		margin-top: 30px;
	}
</style>
